import { request } from '../client';
import type {
  CurrentUser,
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
} from '../types/user';

// 注册
export function register(data: RegisterRequest): Promise<RegisterResponse> {
  return request<RegisterResponse>({ method: 'POST', url: '/dev/auth/register', data });
}

// 登录
export function login(data: LoginRequest): Promise<LoginResponse> {
  return request<LoginResponse>({ method: 'POST', url: '/dev/auth/login', data });
}

// 获取当前用户信息
export function getMe(): Promise<CurrentUser> {
  return request<CurrentUser>({ method: 'GET', url: '/dev/auth/me' });
}

// 登出
export function logout(): Promise<void> {
  return request<void>({ method: 'POST', url: '/dev/auth/logout' });
}
